import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import CloseIcon from '@material-ui/icons/Close';
import flowRight from 'lodash/flowRight';
import get from 'lodash/get';
import pick from 'lodash/pick';

import {
  bool,
  func,
  arrayOf,
  object,
  objectOf,
  string,
  number,
} from 'prop-types';

import { styles } from './UseExistingOptionDialogStyles';
import SearchableSelect from '../../share/SearchableSelect';
import customizationLogo from '../../../assets/img/customization_logo.svg';
import { resourceFields } from '../../../data/Constants';
import { buildSearchableEntities } from '../../../domains/Restrictions';
import * as Functions from '../../../utils/Functions';
import { withRouter } from 'react-router';

let optionFieldKeys = ['id'];
resourceFields.options.forEach(({ key }) => { if (!['customizations', 'outOfStock'].includes(key)) optionFieldKeys.push(key); });

class UseExistingOptionDialog extends Component {
  constructor(props) {
    super(props);

    this.state = this.initializeState(props);
  }

  dialogPaperClass = { paper: this.props.classes.dialogPaper }

  dialogTitleClasses = { root: this.props.classes.dialogTitle }

  searchableFieldTitleClasses = { root: this.props.classes.searchableFieldTitle }

  addOptionButtonClasses = { root: this.props.classes.primaryButton }

  cancelButtonClasses = { root: this.props.classes.cancelButton }

  initializeState = (props) => {
    const state = {};
    const { originalOptions, allOptions } = props;
    state.chosenOptions = buildSearchableEntities(originalOptions);
    state.originalOptionsMap = Functions.getIdsMap(originalOptions, 'id');
    state.allOptionsMap = Functions.getIdToEntityMap(allOptions);
    state.forceRerenderCounter = 0;
    return state;
  }

  onChangeOptions = (value) => {
    this.setState({ chosenOptions: value });
  }

  /**
   * This is needed to let the searchable's choices menu overflow the dialog
   */
  forceRerenderSearchable = () => {
    const { chosenOptions, forceRerenderCounter } = this.state;

    if (forceRerenderCounter < 1) {
      this.setState({ chosenOptions: [] }, () => {
        this.setState({ chosenOptions, forceRerenderCounter: 1 });
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.allOptions && this.props.allOptions) {
      const allOptionsMap = Functions.getIdToEntityMap(this.props.allOptions);
      this.setState({ allOptionsMap });
    }
    if (!prevProps.isOpen && this.props.isOpen) {
      const newState = this.initializeState(this.props);
      this.setState(newState, this.forceRerenderSearchable);
    }
    if (prevProps.isOpen && !this.props.isOpen) {
      this.setState({ forceRerenderCounter: 0 });
    }
  }

  /**
   * Removes keys used for display that the API doesn't accept
   */
  cleanOptionsKeysForAttachRequest = (option) => {
    const cleanedOption = pick(option, optionFieldKeys);
    return cleanedOption;
  }

  getOptionsDiffFromOriginal = () => {
    const { originalOptions } = this.props;
    const { chosenOptions, originalOptionsMap, allOptionsMap } = this.state;
    const chosenOptionsMap = Functions.getIdsMap(chosenOptions, 'value');
    const newlySelectedOptions = Array.isArray(chosenOptions)
      ? chosenOptions.filter(labelValueObj => !originalOptionsMap[labelValueObj.value])
      : [];

    const newlyUnselectedOptions = Array.isArray(originalOptions)
      ? originalOptions.filter(option => !chosenOptionsMap[option.id])
      : [];

    return { newlySelectedOptions, newlyUnselectedOptions };
  }

  getAttachDetachRequestInfo = () => {
    const { allOptionsMap } = this.state;
    const { newlySelectedOptions, newlyUnselectedOptions } = this.getOptionsDiffFromOriginal();
    const { resourceId } = this.props.match.params;
    const attachOptionsRequestsInfo = newlySelectedOptions.map(({ value: optionId }) => ({
      actionName: 'addResource',
      path: ['customizations', resourceId, 'options'],
      option: this.cleanOptionsKeysForAttachRequest(allOptionsMap[optionId]),
    }));

    const detachOptionsRequestsInfo = newlyUnselectedOptions.map(({ id: optionId }) => ({
      actionName: 'deleteResource',
      path: ['customizations', resourceId, 'options', optionId],
    }));
    return attachOptionsRequestsInfo.concat(detachOptionsRequestsInfo);
  }

  submitAttachOptions = async () => {
    const {
      actions,
      apiToken,
      createOrEditModifier,
      onClose,
      originalModifierDetails,
      updateParentOptionsList,
    } = this.props;
    if (createOrEditModifier === 'edit') {
      const requestsInfo = this.getAttachDetachRequestInfo();
      const { chosenOptions, originalOptionsMap, allOptionsMap } = this.state;

      const stayedSelectedsMap = {};
      chosenOptions.forEach(({ value: optionId }) => {
        if (originalOptionsMap[optionId]) stayedSelectedsMap[optionId] = allOptionsMap[optionId];
      });
      const setOptionsArgs = {
        apiToken,
        allOptionsMap,
        originalModifierDetails,
        requestsInfo,
        stayedSelectedsMap,
      };
      const newOptionsList = await actions.setExistingOptionsOnModifier(setOptionsArgs);
      updateParentOptionsList(newOptionsList);
      onClose();
    }
  }

  render() {
    const domNodeToAttachChoicesOverflow = document.querySelector('#useExistingOptionsDialog');
    const {
      isOpen,
      onClose,
      classes,
      searchableOptions,
    } = this.props;
    const { chosenOptions, allOptionsMap } = this.state;

    return (
      <Dialog
        open={isOpen}
        classes={this.dialogPaperClass}
        id="useExistingOptionsDialog"
      >
        <section className={classes.closeIconSection}>
          <IconButton className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </section>
        <section className={classes.contentParent}>
          <img src={customizationLogo} className={classes.dialogImage} />
          <Typography classes={this.dialogTitleClasses}>USE EXISTING OPTIONS</Typography>
          <section className={classes.searchableSelectParent}>
            <Typography classes={this.searchableFieldTitleClasses}>Options:</Typography>
            <SearchableSelect
              isMulti
              onChange={this.onChangeOptions}
              options={searchableOptions}
              value={chosenOptions}
              menuPortalTarget={domNodeToAttachChoicesOverflow}
            />
          </section>
          <Button
            classes={this.addOptionButtonClasses}
            disabled={!allOptionsMap}
            onClick={this.submitAttachOptions}
          >
            IMPORT
          </Button>
          <Button
            classes={this.cancelButtonClasses}
            onClick={onClose}
          >
            cancel
          </Button>
        </section>
      </Dialog>
    );
  }
}

UseExistingOptionDialog.propTypes = {
  actions: objectOf(func),
  allOptions: arrayOf(object),
  apiToken: string,
  createOrEditModifier: string,
  isOpen: bool,
  onClose: func,
  originalModifierDetails: object,
  originalOptions: arrayOf(object),
  optionId: number,
  searchableOptions: arrayOf(object),
  updateParentOptionsList: func,
};

export default withStyles(styles)(withRouter(UseExistingOptionDialog));
